<template>
    <div id="user-profile" class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div v-if="normalUser" class="card-body normal-user-profile">
                        <div class="user-profile-header">
                            <div class="left-side">
                                <img src="./../../assets/img/user-thumbnail.png" alt="">
                                <div class="user-info">
                                    <h3>{{userDetails.firstName}} {{userDetails.lastName}}</h3>
                                    <h4>{{userDetails.email}}</h4>
                                    <span v-if="userDetails.roleId == 1" class="role administrator">Administrator</span>
                                    <span v-else-if="userDetails.roleId == 2 || userDetails.roleId == 12" class="role provisioning">Provisioning</span>
                                    <span v-else-if="userDetails.roleId == 3 || userDetails.roleId == 13" class="role billing">Billing</span>
                                    <span v-else-if="userDetails.roleId == 9" class="role customer-owner">Customer Owner</span>
                                </div>
                            </div>
                            <i class="icon-info" v-b-tooltip.hover title="Please contact your administrator if you need to change your Permissions"></i>
                        </div>
                        <div class="user-profile-boxes">
                            <div class="user-settings email-notifications">
                                <h4 class="header-section">Recieve the Following Emails</h4>
                                <ul class="sidebar-email">
                                    <li>
                                        <FTScheckbox v-model="userDetails.mailingLists.invoice" :label="'Invoices & Statements'"></FTScheckbox>
                                    </li>
                                    <li>
                                        <FTScheckbox v-model="userDetails.mailingLists.maintenance" :label="'Maintenance Notifications'"></FTScheckbox>
                                    </li>
                                    <li>
                                        <FTScheckbox v-model="userDetails.mailingLists.news" :label="'News'"></FTScheckbox>
                                    </li>
                                    <li>
                                        <FTScheckbox v-model="userDetailsAlertsEmail" @change.native="checkOneEmailCheckboxUserDetails()" :label="'Data Guard Alerts'"></FTScheckbox>
                                    </li>
                                </ul>
                                <ul class="email-updates">
                                    <li>
                                        <FTScheckbox v-model="userDetails.mailingLists.usageEach" :disable="!userDetailsAlertsEmail || (userDetails.mailingLists.usageEach == true && userDetails.mailingLists.usageDaily == false)" :label="'Real Time '"></FTScheckbox>
                                    </li>
                                    <li>
                                        <FTScheckbox @change.native="unselectDailyUserDetails()" v-model="userDetails.mailingLists.usageDaily" :disable="!userDetailsAlertsEmail || (userDetails.mailingLists.usageDaily == true && userDetails.mailingLists.usageEach == false)" :label="'Daily Summary '"></FTScheckbox>
                                    </li>
                                    <li class="additionaly-padding">
                                        <FTScheckbox v-model="userDetails.mailingLists.dailyRecurring" :disable="!userDetails.mailingLists.usageDaily" :label="'Daily Recurring '"></FTScheckbox>
                                    </li>
                                </ul>
                            </div>
                            <div class="user-settings sms-notifications">
                                <h4 class="header-section">SMS notifications</h4>
                                <FTScheckbox class="sms-usage-alert" :label="'Data Guard Alerts '" @change.native="setPhoneValidation()" v-model="userDetailsAlertsSMS"></FTScheckbox>
                                <div class="phone-number-box">
                                    <fieldset :class="[phoneNumberValidation.passed == false ? 'error-field' : '']">
                                        <vue-tel-input class="form-control" v-bind="bindProps" @input="parsePhoneNumber" :disabled="!userDetailsAlertsSMS" v-model="phoneNumber" name="errorPhoneNumber"></vue-tel-input>
                                        <span v-if="!phoneNumberValidation.passed && phoneNumberValidation.required" class="validate-warning">Please type phone number in right format</span>
                                    </fieldset>
                                </div>

                                <div class="sms-updates">
                                    <FTScheckbox v-model="userDetails.smsNotifications.usageEach" :disable="!phoneNumberValidation.passed || (userDetails.smsNotifications.usageEach && userDetails.smsNotifications.usageDaily == false) || userDetailsAlertsSMS == false" :label="'Real Time'"></FTScheckbox>
                                    <FTScheckbox v-model="userDetails.smsNotifications.usageDaily" :disable="!phoneNumberValidation.passed || (userDetails.smsNotifications.usageDaily && userDetails.smsNotifications.usageEach == false) || userDetailsAlertsSMS == false" :label="'Daily Summary'"></FTScheckbox>
                                </div>
                            </div>
                            <div class="user-settings user-permissions">
                                <h4 class="header-section">Permissions</h4>
                                <ul>
                                    <li v-if="userDetails.alertModificationAllowed">You can clear New Usage Alerts</li>
                                    <li v-else>You can't clear New Usage Alerts</li>
                                </ul>
                            </div>
                            <div v-if="resetPasswordAvailable" class="user-settings reset-password">
                                <h4 class="header-section">Password</h4>
                                <div class="area-reset">
                                    <button class="btn btn-primary" @click="$refs['resetPassword'].show()">Reset Password</button>
                                    <span>A mail with a reset password link will be send to:</span>
                                    <span>{{userDetails.email}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="save-btn-box">
                            <button class="btn btn-success save-btn" :disabled="checkChanges() == false" @click="saveChanges()">Save changes</button>
                        </div>
                    </div>
                    <div v-else class="card-body super-admin-profile">
                        <div class="user-profile-header">
                            <div class="left-side">
                                <img src="./../../assets/img/user-thumbnail.png" alt="">
                                <div class="user-info">
                                    <h3>{{userDetails.firstName}} {{userDetails.lastName}}</h3>
                                    <h4>{{userDetails.email}}</h4>
                                    <span v-if="userDetails.roleId == 4" class="role owner">Owner</span>
                                    <span v-else-if="userDetails.roleId == 5" class="role super-admin">Super Admin</span>
                                    <span v-else-if="userDetails.roleId == 6" class="role fulfilment">Fulfilment</span>
                                    <span v-else-if="userDetails.roleId == 8" class="role support">Support</span>
                                    <span v-else-if="userDetails.roleId == 10" class="role sales">Sales</span>
                                </div>
                            </div>
                            <i class="icon-info" v-b-tooltip.hover title="Please contact your administrator if you need to change your Permissions"></i>
                        </div>
                        <div class="timezone-container">
                            <label for="time-zone">Timezone</label>
                            <select class="form-control timezone-select" name="time-zone" id="time-zone" @change="sendTimezoneUpdate()" v-model="userDetails.timezoneId">
                                <option v-for="zone in timeZones" v-bind:key="zone.id" :value="zone.id">{{zone.tzdbId.replace(/_/g, ' ')}}</option>
                            </select>
                        </div>
                        <div class="admin-profile-boxes">
                            <div class="admin-settings company-specific-permissions">
                                <h4 class="header-section">Company Specific Permissions</h4>
                                <div class="permissions-list">
                                    <div v-for="perm of companyPermissions">
                                        <div v-if="perm.selected && perm.code != 'ALL_COMPANIES_ACCESS'" class="permission-item">
                                            <span class="permission-name">{{perm.name}}</span>
                                            <span class="description">{{perm.description}}</span>
                                        </div>
                                        <div v-else-if="perm.code == 'ALL_COMPANIES_ACCESS'">
                                            <div v-if="perm.selected == 'ALL_COMPANIES_ACCESS'" class="permission-item">
                                                <span class="permission-name">All companies access</span>
                                                <span class="description">User will have acces to all companies</span>
                                            </div>
                                            <div v-else class="permission-item">
                                                <span class="permission-name">Company Access</span>
                                                <span class="description">User will have access to selected companies</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="admin-settings super-admin-specific-permissions">
                                <h4 class="header-section">Super Admin Specific Permissions</h4>
                                <div class="permissions-list">
                                    <div v-for="perm of adminPermissions" v-if="perm.selected" class="permission-item">
                                        <span class="permission-name">{{perm.name}}</span>
                                        <span class="description">{{perm.description}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="admin-settings reset-password">
                                <h4 class="header-section">Password</h4>
                                <div class="area-reset">
                                    <button class="btn btn-primary" @click="$refs['resetPassword'].show()">Reset Password</button>
                                    <span>A mail with a reset password link will be send to:</span>
                                    <span>{{userDetails.email}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="resetPassword" id="resetPassword" :class="['modal-reset-passwprd']" hide-footer centered>

            <i class="fa fa-lock" aria-hidden="true"></i>

            <h3>Reset Password</h3>
            <h4>Do you really want reset password?</h4>

            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['resetPassword'].hide()">No</b-button>
                <b-button v-if="userLevel != 'Super Admin'" variant="success" @click="resetPassword()">Yes</b-button>
                <b-button v-else variant="success" @click="resetAdminPassword()">Yes</b-button>
            </div>

            <div v-if="resetingPassword" class="reseting-password">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from "axios";
import VueSession from "vue-session";
import VueCookies from "vue-cookies";
import globalStore from "../../variables";
import FTScheckbox from "../../ftsComponents/FTScheckbox";
import { VueTelInput } from 'vue-tel-input'
import awesomePhonenumber from "awesome-phonenumber";

Vue.use(VueSession);
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

export default {
    name: 'UserProfile',
    components: {
        FTScheckbox,
        VueTelInput,
        awesomePhonenumber
    },
    data() {
        return {
            resetPasswordAvailable: false,
            userLevel: '',
            userLevelName: '',
            userEmail: '',
            userId: '',
            userDetails: {
                alertModificationAllowed: null,
                email: null,
                firstName: null,
                lastName: null,
                mailingLists: {
                    news: null,
                    invoice: null,
                    maintenance: null,
                    usageEach: null,
                    usageDaily: null,
                    dailyRecurring: null
                },
                phoneNumber: {
                    dialCode: null,
                    number: null
                },
                roleId: null,
                smsNotifications: {
                    usageEach: null,
                    usageDaily: null
                },
            },
            userDetailsAlertsEmail: true,
            userDetailsAlertsSMS: false,
            initialUserDetailsAlertsSMS: false,
            phoneNumber: '',
            phoneNumberValidation: {
                passed: false,
                required: false
            },
            adminData: {},
            emailToReset: '',
            resetingPassword: false,
            adminDataValidation: {
                email: null,
                firstName: null,
                secondName: null
            },
            normalUser: true,
            adminPermissions: [],
            companyPermissions: [],
            adminCompaniesAccess: '',
            timeZones: [],
            bindProps: {
                defaultCountry: "USA",
                disabledFetchingCountry: false,
                disabled: false,
                disabledFormatting: false,
                placeholder: "Enter a phone number",
                required: true,
                enabledCountryCode: true,
                enabledFlags: true,
                preferredCountries: ["USA"],
                onlyCountries: [],
                ignoredCountries: [],
                autocomplete: "off",
                name: "telephone",
                maxLen: 25,
                wrapperClasses: "",
                inputClasses: "",
                dropdownOptions: {
                    disabledDialCode: false
                }
            },
            initialEmail: {
                usageDaily: false,
                usageEach: false,
                dailyRecurring: false,
                news: false,
                invoice: false,
                maintenance: false
            },
            initialSMS: {
                usageDaily: false,
                usageEach: false
            },
            initialPhoneNumber: {
                dialCode: null,
                number: null
            }
        }
    },
    methods: {
        getUserDetails() {
            Axios.get(`${globalStore.data.restApiUrl}/user-settings/users`)
                .then(response => {
                    this.userDetails = response.data

                    this.userDetailsAlertsEmail = this.userDetails.mailingLists.usageDaily || this.userDetails.mailingLists.usageEach || this.userDetails.mailingLists.dailyRecurring ? true : false
                    this.userDetailsAlertsSMS = this.userDetails.smsNotifications.usageDaily || this.userDetails.smsNotifications.usageEach ? true : false

                    this.userDetails.mailingLists.usageDaily = this.userDetails.mailingLists.dailyRecurring ? true : this.userDetails.mailingLists.usageDaily

                    this.userDetails.smsNotifications.usageDaily = this.userDetails.smsNotifications.usageDaily ? true : false
                    this.userDetails.smsNotifications.usageEach = this.userDetails.smsNotifications.usageEach ? true : false

                    this.setInitialData();

                    this.setPhoneValidation();
                }).catch(error => {
                    console.log(error)
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Something was wrong with getting user details. Please contact with support.',
                        duration: 5000,
                    });
                    return false
                })
        },
        setInitialData() {
            this.initialUserDetailsAlertsSMS = this.userDetails.smsNotifications.usageDaily || this.userDetails.smsNotifications.usageEach ? true : false

            this.initialEmail = {
                usageDaily: this.userDetails.mailingLists.dailyRecurring ? true : this.userDetails.mailingLists.usageDaily,
                usageEach: this.userDetails.mailingLists.usageEach ? true : false,
                dailyRecurring: this.userDetails.mailingLists.dailyRecurring ? true : false,
                news: this.userDetails.mailingLists.news ? true : false,
                invoice: this.userDetails.mailingLists.invoice ? true : false,
                maintenance: this.userDetails.mailingLists.maintenance ? true : false
            }

            this.initialSMS = {
                usageDaily: this.userDetails.smsNotifications.usageDaily ? true : false,
                usageEach: this.userDetails.smsNotifications.usageEach ? true : false
            }

            if (this.userDetails.phoneNumber == null) {
                this.initialPhoneNumber = {
                    dialCode: null,
                    number: null
                }
            } else {
                this.phoneNumber = this.userDetails.phoneNumber.dialCode + this.userDetails.phoneNumber.number
                this.phoneNumberValidation.passed = true;
                setTimeout(() => {
                    this.phoneNumber = this.userDetails.phoneNumber.number
                }, 500)
                this.initialPhoneNumber = {
                    dialCode: this.userDetails.phoneNumber.dialCode ? this.userDetails.phoneNumber.dialCode : null,
                    number: this.userDetails.phoneNumber.number ? this.userDetails.phoneNumber.number : null
                }
            }
        },
        checkChanges() {
            let change = false
            if (this.initialEmail.usageDaily != this.userDetails.mailingLists.usageDaily ||
                this.initialEmail.usageEach != this.userDetails.mailingLists.usageEach ||
                this.initialEmail.dailyRecurring != this.userDetails.mailingLists.dailyRecurring ||
                this.initialEmail.news != this.userDetails.mailingLists.news ||
                this.initialEmail.maintenance != this.userDetails.mailingLists.maintenance ||
                this.initialEmail.invoice != this.userDetails.mailingLists.invoice) {
                change = true
            }

            if (this.initialSMS.usageDaily != this.userDetails.smsNotifications.usageDaily || this.initialSMS.usageEach != this.userDetails.smsNotifications.usageEach) {
                change = true
            }

            if (this.userDetailsAlertsSMS != this.initialUserDetailsAlertsSMS) {
                change = true
            }

            if (this.initialPhoneNumber.dialCode == null && this.initialPhoneNumber.number == null) {
                if (this.phoneNumberValidation.passed && (this.userDetails.smsNotifications.usageDaily || this.userDetails.smsNotifications.usageEach)) {
                    change = true
                }
            } else {
                if (this.initialPhoneNumber.dialCode != this.userDetails.phoneNumber.dialCode || this.initialPhoneNumber.number != this.userDetails.phoneNumber.number) {
                    change = true
                }
            }
            return change
        },
        setPhoneValidation() {
            if (this.userDetailsAlertsSMS) {
                this.phoneNumberValidation.required = true;
                if (this.userDetails.smsNotifications.usageDaily == false && this.userDetails.smsNotifications.usageEach == false) {
                    this.userDetails.smsNotifications.usageDaily = true
                }
            } else {
                this.phoneNumberValidation.required = false;
                this.userDetails.smsNotifications.usageDaily = false
                this.userDetails.smsNotifications.usageEach = false
            }
        },
        saveChanges() {
            let parsedData = {}

            if (this.initialEmail.usageDaily != this.userDetails.mailingLists.usageDaily ||
                this.initialEmail.usageEach != this.userDetails.mailingLists.usageEach ||
                this.initialEmail.dailyRecurring != this.userDetails.mailingLists.dailyRecurring ||
                this.initialEmail.news != this.userDetails.mailingLists.news ||
                this.initialEmail.maintenance != this.userDetails.mailingLists.maintenance ||
                this.initialEmail.invoice != this.userDetails.mailingLists.invoice) {
                parsedData.mailingLists = {
                    usageDaily: this.userDetails.mailingLists.dailyRecurring ? false : this.userDetails.mailingLists.usageDaily,
                    usageEach: this.userDetails.mailingLists.usageEach,
                    dailyRecurring: this.userDetails.mailingLists.dailyRecurring,
                    news: this.userDetails.mailingLists.news,
                    maintenance: this.userDetails.mailingLists.maintenance,
                    invoice: this.userDetails.mailingLists.invoice
                }
            }

            if (this.initialSMS.usageDaily != this.userDetails.smsNotifications.usageDaily || this.initialSMS.usageEach != this.userDetails.smsNotifications.usageEach) {
                parsedData.smsNotifications = {
                    usageDaily: this.userDetails.smsNotifications.usageDaily,
                    usageEach: this.userDetails.smsNotifications.usageEach
                }
            }

            if (this.userDetailsAlertsSMS != this.initialUserDetailsAlertsSMS) {
                if (this.userDetailsAlertsSMS) {
                    if (this.userDetailsAlertsSMS) {
                        if (this.initialPhoneNumber.dialCode == null && this.initialPhoneNumber.number == null) {
                            if (this.phoneNumberValidation.passed && (this.userDetails.smsNotifications.usageDaily || this.userDetails.smsNotifications.usageEach)) {
                                parsedData.phoneNumber = {
                                    dialCode: this.userDetails.phoneNumber.dialCode,
                                    number: this.userDetails.phoneNumber.number
                                }
                            }
                        } else {
                            if (this.initialPhoneNumber.dialCode != this.userDetails.phoneNumber.dialCode || this.initialPhoneNumber.number != this.userDetails.phoneNumber.number) {
                                parsedData.phoneNumber = {
                                    dialCode: this.userDetails.phoneNumber.dialCode,
                                    number: this.userDetails.phoneNumber.number
                                }
                            }
                        }
                    } else { //here
                        if (this.phoneNumberValidation.passed && this.userLevel != 9) {
                            parsedData.deletePhoneNumber = true
                        }
                    }
                } else {
                    if (this.userLevel != 9) {
                        parsedData.deletePhoneNumber = true
                    }
                    parsedData.smsNotifications = {
                        usageDaily: false,
                        usageEach: false
                    }
                }
            } else {
                if (this.userDetailsAlertsSMS) {
                    if (this.initialPhoneNumber.dialCode == null && this.initialPhoneNumber.number == null) {
                        if (this.phoneNumberValidation.passed && (this.userDetails.smsNotifications.usageDaily || this.userDetails.smsNotifications.usageEach)) {
                            parsedData.phoneNumber = {
                                dialCode: this.userDetails.phoneNumber.dialCode,
                                number: this.userDetails.phoneNumber.number
                            }
                        }
                    } else {
                        if (this.initialPhoneNumber.dialCode != this.userDetails.phoneNumber.dialCode || this.initialPhoneNumber.number != this.userDetails.phoneNumber.number) {
                            parsedData.phoneNumber = {
                                dialCode: this.userDetails.phoneNumber.dialCode,
                                number: this.userDetails.phoneNumber.number
                            }
                        }
                    }
                } else {
                    if (this.phoneNumberValidation.passed) {
                        parsedData.deletePhoneNumber = true
                    }
                }
            }

            if (this.phoneNumberValidation.required && this.phoneNumberValidation.passed == false) {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Phone number invalid',
                    text: 'You must type correct phone number before saving those settings.',
                    duration: 5000,
                });
                return false
            }

            Axios.patch(globalStore.data.restApiUrl + "/user-settings", parsedData)
                .then(response => {
                    this.setInitialData();
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Profile updated',
                        text: 'Your profile has been updated',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.errors[0].errorCode == 'BadApiRequestException' &&  error.response.data.errors[0].errorMessage == 'Phone number: ' + this.userDetails.phoneNumber.dialCode + ' ' + this.userDetails.phoneNumber.number + ' is already taken') {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Profile not updated',
                            text: 'Phone number: ' + this.userDetails.phoneNumber.dialCode + ' ' + this.userDetails.phoneNumber.number + ' is already taken',
                            duration: 5000,
                        });
                    } else {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Profile not updated',
                            text: 'An error has occured during updating your profile.',
                            duration: 5000,
                        });
                    }
                })
        },
        getSuperAdminDetails() {
            Axios.get(`${globalStore.data.restApiUrl}/admin/users/profile`)
                .then(response => {
                    this.userDetails = response.data
                    this.adminData = {
                        email: response.data.email,
                        firstName: response.data.firstName,
                        lastName: response.data.lastName
                    }
                    this.adminPermissions = []
                    this.setPermissions(this.userDetails.userPermissions)
                }).catch(error => {
                console.log(error)
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Something was wrong with getting user details. Please contact with support.',
                    duration: 5000,
                });
                return false
            })
        },
        setPermissions(permissions) {
            Axios.get(globalStore.data.restApiUrl + '/admin/super-admin-permissions')
                .then(response => {
                    for (let item of response.data) {
                        if (item.permissionType == 'COMPANY_SPECIFIC') {
                            for (let permission of item.typePermissions) {
                                if (permission.code == 'ALL_COMPANIES_ACCESS') {
                                    if (permissions.indexOf(permission.code) > -1) {
                                        permission.selected = 'ALL_COMPANIES_ACCESS'
                                        this.companyPermissions.push(permission)
                                    } else {
                                        permission.selected = false
                                        this.companyPermissions.push(permission)
                                    }
                                } else {
                                    if (permissions.indexOf(permission.code) > -1) {
                                        permission.selected = true
                                    } else {
                                        permission.selected = false
                                    }
                                    this.companyPermissions.push(permission)
                                }
                            }
                        } else if (item.permissionType == 'SUPER_ADMIN_SPECIFIC') {
                            for (let permission of item.typePermissions) {
                                if (permission.name != 'Super Admin Panel') {
                                    if (permissions.indexOf(permission.code) > -1) {
                                        permission.selected = true
                                    } else {
                                        permission.selected = false
                                    }
                                    this.adminPermissions.push(permission)
                                }
                            }
                        }
                    }
                })
        },
        resetPassword() {
            this.resetingPassword = true;

            Axios.post(globalStore.data.restApiUrl + '/register/reset-own-password')
                .then(response => {
                    this.resetingPassword = false;
                    this.$refs['resetPassword'].hide()
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Reset password done',
                        text: 'Password Reset Email Sent Successfully',
                        duration: 5000,
                    });
                }).catch(error => {
                this.resetingPassword = false;
                this.$refs['resetPassword'].hide()

                if (error.response.status != 429) {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Reset password not working',
                        text: 'Error Resetting Password - Contact Support',
                        duration: 5000,
                    });
                }
            })
        },
        resetAdminPassword() {
            this.resetingPassword = true;

            Axios.post(globalStore.data.restApiUrl + '/register/reset-own-password')
                .then(response => {
                    this.resetingPassword = false;
                    this.$refs['resetPassword'].hide()
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Reset password done',
                        text: 'Password Reset Email Sent Successfully',
                        duration: 5000,
                    });
                }).catch(error => {
                this.resetingPassword = false;
                this.$refs['resetPassword'].hide()

                if (error.response.status != 429) {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Reset password not working',
                        text: 'Error Resetting Password - Contact Support',
                        duration: 5000,
                    });
                }
            })
        },
        revertChanges() {
            this.userDetails.email = this.adminData.email;
            this.userDetails.firstName = this.adminData.firstName;
            this.userDetails.lastName = this.adminData.lastName;
            this.adminDataValidation.firstName = null;
            this.adminDataValidation.lastName = null;
            this.adminDataValidation.email = null;
        },
        sendChanges() {
            if (this.userDetails.firstName == '' || this.userDetails.firstName == null) {
                this.adminDataValidation.firstName = false;
            } else {
                this.adminDataValidation.firstName = true;
            }
            if (this.userDetails.lastName == '' || this.userDetails.lastName == null) {
                this.adminDataValidation.lastName = false;
            } else {
                this.adminDataValidation.lastName = true;
            }
            if (this.userDetails.email == '' || this.userDetails.email == null) {
                this.adminDataValidation.email = false;
            } else {
                this.adminDataValidation.email = true;
            }

            if (this.adminDataValidation.firstName && this.adminDataValidation.lastName && this.adminDataValidation.email) {

                let parsedData = {};

                if (this.userDetails.email != this.adminData.email) {
                    parsedData.email = this.userDetails.email;
                }
                if (this.userDetails.firstName != this.adminData.firstName) {
                    parsedData.firstName = this.userDetails.firstName;
                }
                if (this.userDetails.lastName != this.adminData.lastName) {
                    parsedData.lastName = this.userDetails.lastName;
                }

                Axios.patch( globalStore.data.restApiUrl + '/admin/users/' + this.userDetails.userId, parsedData)
                .then(response => {

                    this.adminDataValidation.firstName = null;
                    this.adminDataValidation.lastName = null;
                    this.adminDataValidation.email = null;


                    if (this.userDetails.email != this.adminData.email) {
                        this.adminData.email = this.userDetails.email;
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'User profile updated',
                            text: 'Your changes have been saved.<br/>Because you changed email, you will be log out now. Please log in again with new credentials.',
                            duration: 8000,
                        });
                        this.logout();
                    } else {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'User profile updated',
                            text: 'Your changes have been saved',
                            duration: 5000,
                        });
                    }
                    if (this.userDetails.firstName != this.adminData.firstName) {
                        this.adminData.firstName = this.userDetails.firstName;
                    }
                    if (this.userDetails.lastName != this.adminData.lastName) {
                        this.adminData.lastName = this.userDetails.lastName;
                    }
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'User profile error',
                        text: 'Your changes have not been saved',
                        duration: 5000,
                    });
                    console.log(error)
                })
            }
        },
        logout() {
            let noAdmin = [4,5,6,8]
            if (noAdmin.indexOf(this.userLevel) == -1) {
                this.$cookies.remove('token')
                this.$cookies.remove('refreshToken')
                this.$cookies.remove('refreshFlag')
                this.$cookies.remove('defaultLogin')
                this.$cookies.remove('lastActiviti')
                this.$cookies.remove('multiCompanyAccess')
                this.$cookies.remove('multiCompanyAccessId')
                this.$cookies.remove('isSA')
                this.$cookies.remove('tokenSetTime')
                this.$cookies.remove('userId')
                this.$cookies.remove('userLevelId')
                this.$cookies.remove('userEmail')
                this.$cookies.remove('userLevel')
                this.$cookies.remove('permissions')
                this.$cookies.remove('firstName')
                this.$cookies.remove('lastName')
                this.$cookies.remove('companyId')
                this.$cookies.remove('companyName')
                this.$cookies.remove('typeAccount')
                this.$cookies.remove('simonCarrierAvailable')
                this.$cookies.remove('tmobileCarrierAvailable')
                this.$cookies.remove('vodafoneCarrierAvailable')
                this.$cookies.remove('koreCarrierAvailable')
                this.$cookies.remove('nbIoTPlans')
                this.$cookies.remove('voiceAccess')
                this.$cookies.remove('tier2Roaming')
                this.$cookies.remove('catM1Plans')
                this.$cookies.remove('simonActiveReady')
                this.$cookies.remove('coldStockAccess')
                this.$cookies.remove('hotSpotAccess')
                this.$cookies.remove('acceptedAgreementId')
            } else {
                this.$session.destroy();
                this.$cookies.remove('defaultLogin')
            }
            this.$router.push("/login");
        },
        getTimezones() {
            Axios.get(`${globalStore.data.restApiUrl}/time-zones`)
                .then(response => {
                    this.timeZones = response.data
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Get Timezones list',
                    text: 'Something was wrong with get timezones list.',
                    duration: 5000,
                });
                return false;
            })
        },
        sendTimezoneUpdate() {
            Axios.patch(globalStore.data.restApiUrl + '/admin/users/timezone/' + this.userDetails.timezoneId)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Time zone updated',
                        text: 'You succesfully updated time zone.',
                        duration: 5000,
                    });


                    let refreshToken = this.$session.get('refreshToken');

                    Axios.post(globalStore.data.restApiUrl + `/refresh?grant_type=refresh_token&&refresh_token=${refreshToken}`)
                        .then(response => {
                            let currentTime = Date.now()
                            this.$session.set("token", response.data.accessToken, "30MIN");
                            this.$session.set('refreshToken', response.data.refreshToken, "30MIN");
                            this.$session.set('tokenSetTime', currentTime)
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Update went wrong.',
                            text: 'Updating timezone in your current login session went wrong. To apply change, please logout and log in once more.',
                            duration: 5000,
                        });
                    })
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Time zone update error',
                        text: 'An error has occured during updating time zone.',
                        duration: 5000,
                    });
                })
        },
        checkOneEmailCheckboxUserDetails() {
            if (this.userDetailsAlertsEmail) {
                this.userDetails.mailingLists.usageDaily = true;
            } else {
                this.userDetails.mailingLists.usageEach = false;
                this.userDetails.mailingLists.usageDaily = false;
            }
        },
        unselectDailyUserDetails() {
            if (this.userDetails.mailingLists.usageDaily == false && this.userDetails.mailingLists.dailyRecurring == true) {
                this.userDetails.mailingLists.dailyRecurring =  false
            }
        },
        parsePhoneNumber(number, isValid, country) {
            if (isValid.isValid) {
                this.phoneNumberValidation.passed = true;
                if (this.userDetails.phoneNumber == null) {
                    this.userDetails.phoneNumber = {}
                }
                this.userDetails.phoneNumber.dialCode = isValid.number.e164.slice(0,(isValid.number.e164.length - isValid.number.significant.length));
                this.userDetails.phoneNumber.number = isValid.number.significant;
                if (this.userDetails.smsNotifications.usageDaily == false && this.userDetails.smsNotifications.usageEach == false) {
                    this.userDetails.smsNotifications.usageDaily = true
                }
            } else {
                this.phoneNumberValidation.passed = false;
            }
        }
    },
    created() {
        let noAdmin = [4,5,6,8,10]
        this.userLevel = this.$cookies.get('userLevelId') ? this.$cookies.get('userLevelId') : this.$session.get('userLevelId');
        if (noAdmin.indexOf(this.userLevel) == -1) {
            this.userLevelName = this.$cookies.get('userLevel');
            this.userEmail = this.$cookies.get('userEmail');
            this.userId = this.$cookies.get('userId')
            this.normalUser = true
            this.getUserDetails()
        } else {
            this.userLevelName = this.$session.get('userLevel');
            this.userEmail = this.$session.get('userEmail');
            this.normalUser = false
            this.getSuperAdminDetails();
            this.getTimezones();
        }
        if (this.$cookies.get('defaultLogin') == 'true') {
            this.resetPasswordAvailable = true
        } else {
            this.resetPasswordAvailable = false
        }
    }
}
</script>

<style lang="scss">
#user-profile {
    .card-body {
        position: relative;
        padding: 0;
        display: flex;
        &.normal-user-profile,
        &.super-admin-profile {
            flex-direction: column;
        }
        .user-profile-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 20px;
            .left-side {
                display: flex;
                img {
                    width: 22px;
                    height: 22px;
                    margin: 0 14px 0 0;
                }
                .user-info {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    h3 {
                        margin: 0 0 4px;
                        font-size: 15px;
                        font-weight: 700;
                    }
                    h4 {
                        margin: 0 0 10px;
                        color: #515B65;
                        font-size: 12px;
                        font-weight: 400;
                    }
                    .role {
                        margin: 0;
                        padding: 4px 16px;
                        font-size: 12px;
                        color: #fff;
                        -webkit-border-radius: 12px;
                        -moz-border-radius: 12px;
                        border-radius: 12px;
                        &.administrator {
                            background-color: #fc4d4d;
                        }
                        &.provisioning {
                            background-color: #7b4dfc;
                        }
                        &.billing {
                            background-color: #4db0fc;
                        }
                        &.customer-owner {
                            background-color: #000;
                        }
                        &.owner {
                            background-color: #fc4d4d;
                        }
                        &.super-admin {
                            background-color: #fc4de5;
                        }
                        &.fulfilment {
                            background-color: #4db0fc;
                        }
                        &.support {
                            background-color: #7b4dfc;
                        }
                        &.sales {
                            background-color: #00C4B0;
                        }
                    }
                }
            }
        }
        .timezone-container {
            padding: 0 20px;
            .timezone-select {
                width: 360px;
                background: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 8 4.2' style='enable-background:new 0 0 8 4.2;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%230088FF;%7D%0A%3C/style%3E%3Cpolygon class='st0' points='4,4.2 0,0 8,0 '/%3E%3C/svg%3E%0A") no-repeat right 0.75rem center/8px 10px #ffffff;
            }
        }
        .user-profile-boxes {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 20px;

            .user-settings {
                display: flex;
                flex-direction: column;
                padding: 20px;
                max-width: calc(25% - 10px);
                flex-grow: 1;
                margin-bottom: 20px;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                border: 1px solid #c8ced3;

                &:first-child {
                    margin-left: 0;
                }

                .header-section {
                    font-size: 15px;
                }

                &.email-notifications {
                    .email-updates {
                        padding: 0;
                        margin: 0 0 0 20px;
                        list-style: none;

                        li {
                            &.additionaly-padding {
                                padding-left: 40px;
                            }
                        }
                    }

                    .sidebar-email {
                        padding: 0;
                        margin: 0;
                        list-style: none;

                        li {
                            display: block;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                &.sms-notifications {
                    .phone-number-box {
                        position: relative;
                        display: flex;
                        flex-wrap: nowrap;
                        padding-left: 20px;
                        margin-bottom: 10px;
                        align-items: center;

                        .phone-number-input {
                            -webkit-border-radius: 5px;
                            -moz-border-radius: 5px;
                            border-radius: 5px;
                            border: 1px solid #c9cfd4;
                            background-color: #f0f3f5;
                            padding: 10px 16px;
                            outline: none;
                        }

                        .fa-info {
                            display: inline-block;
                            vertical-align: top;
                            width: 16px;
                            height: 16px;
                            margin: 0 20px;
                            border: 2px solid #80868D;
                            background-color: transparent;
                            text-align: center;
                            line-height: 16px;
                            border-radius: 16px;
                            cursor: pointer;

                            &:before {
                                display: inline-block;
                                vertical-align: top;
                                font-size: 9px;
                                line-height: 12px;
                                color: #80868D;
                            }

                            & + .phone-number-tooltip {
                                display: none;
                                position: absolute;
                                left: 100%;
                                top: 0;
                                width: 350px;
                                padding: 8px 10px;
                                background-color: #241717;
                                -webkit-border-radius: 5px;
                                -moz-border-radius: 5px;
                                border-radius: 5px;
                                color: #ffffff;
                            }

                            &:hover {
                                & + .phone-number-tooltip {
                                    display: block;
                                }
                            }
                        }
                    }

                    .sms-updates {
                        display: flex;
                        padding: 0 0 0 20px;

                        .FTScheckbox {
                            max-width: 50%;
                            flex-grow: 1;
                        }
                    }
                }

                &.user-permissions {
                }

                &.reset-password {
                    display: flex;
                    flex-direction: column;

                    .area-reset {
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;

                        .btn-primary {
                            margin: 0 0 10px;
                        }

                        span {
                            font-size: 12px;
                            color: #515B65;
                        }
                    }
                }
            }
        }
        .admin-profile-boxes {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 20px;
            .admin-settings {
                width: calc(50% - 10px);
                display: flex;
                flex-direction: column;
                padding: 20px;
                margin-bottom: 20px;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                border: 1px solid #c8ced3;

                .header-section {
                    margin-bottom: 20px;
                    font-size: 15px;
                }

                .permissions-list {
                    display: flex;
                    flex-direction: column;
                    .permission-item {
                        display: flex;
                        align-items: center;
                        margin: 0 20px 14px 0;
                        &:before {
                            content: '';
                            display: inline-block;
                            height: 6px;
                            min-width: 6px;
                            border-radius: 50%;
                            display: inline-block;
                            background-color: #0088ff;
                            margin-right: 8px;
                        }
                        .permission-name {
                            min-width: 170px;
                            width: 170px;
                            font-size: 15px;
                        }
                        .description {
                            max-width: 320px;
                            font-size: 14px;
                            color: #515B65;
                        }
                    }
                }
                &.reset-password {
                    display: flex;
                    flex-direction: column;
                    .area-reset {
                        flex-grow:1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        .btn-primary {
                            margin: 0 0 10px;
                        }
                        span {
                            font-size: 12px;
                            color: #515B65;
                        }
                    }
                }
            }
        }
        .save-btn-box {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding: 0 20px 20px;
        }
    }
}

#resetPassword {
    .modal-header {
        padding-bottom: 0;
    }

    .modal-body {
        padding-top: 0;
        text-align: center;
        position: static;

        i {
            color: #0088FF;
            margin-bottom: 15px;
        }

        img {
            width: 15px;
            margin-bottom: 15px;
        }

        h3 {
            display: block;
            margin-bottom: 18px;
            font-size: 15px;
            line-height: 18px;
            font-weight: 700;
            color: #2F353A;
        }

        h4 {
            display: block;
            margin-bottom: 40px;
            font-size: 14px;
            line-height: 24px;
            color: #515B65;
        }

        .button-wrapper {
            button {
                margin: 0 5px;
                padding-left: 15px;
                padding-right: 15px;
            }
        }

        .reseting-password {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(255, 255, 255, 0.7);
            .sk-wave {
                height: 60px;
                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }
        }
    }
}

.dark-theme {

    .modal-content {
        background-color: #3A4149;
        border-color: #1A1C1D;

        .close {
            color: #fff;
        }
    }

    #resetPassword {
        .modal-body {
            h3 {
                color: #fff;
            }
            h4 {
                color: #fff;
            }

            .reseting-password {
                background-color: rgba(0, 0, 0, 0.7);
            }
        }
    }
    #user-profile {
        .card-body {
            .user-profile-boxes .user-settings {
                border: 1px solid #1A1C1D;
            }
            .user-profile-header {
                .left-side {
                    img {
                        content: url("/img/avatars/user.png");
                    }

                    .user-info {
                        h4 {
                            color: #fff;
                        }
                    }
                }
            }
            .timezone-container {
                .timezone-select {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                    color: #ffffff;
                }
            }
            .admin-profile-boxes {
                .admin-settings {
                    border: 1px solid #1A1C1D !important;
                    .permissions-list {
                        .permission-item {
                            .description {
                                color: #fff;
                            }
                        }
                    }

                    &.reset-password {
                        .area-reset {
                            span {
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    #user-profile {
        .card-body {
            .user-profile-boxes {
                .user-settings {
                    width: calc(50% - 10px);
                    max-width: none;
                    flex-grow: initial;
                }
            }
        }
    }
}

@media screen and (max-width: 992px) {
    #user-profile {
        .card-body {
            .admin-profile-boxes {
                .admin-settings {
                    .permissions-list {
                        .permission-item {
                            flex-wrap: wrap;
                            .permission-name {
                                width: calc(100% - 14px);
                            }
                            .description {
                                max-width: none;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 600px) {
    #user-profile {
        .card-body {
            .timezone-container {
                .timezone-select {
                    width: 100%;
                }
            }
            .admin-profile-boxes {
                flex-direction: column;
                .admin-settings {
                    width: 100%;
                }
            }
            .user-profile-boxes {
                .user-settings {
                    width: 100%;
                    max-width: none;
                    flex-grow: initial;
                }
            }
        }
    }
}

</style>
